import { wrapReducer } from "@client/content/lib/helper";
import { type BlogList } from "@client/content/modules/BlogList/types";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type FetchPageBeginActionData, type FetchPageSuccessActionData } from "./actions";

const reducer = (state: BlogList.State, action: ReduxAction<any>): BlogList.State => {
  switch (action.type) {
    case Actions.FetchPageBegin: {
      const { page } = action.data as FetchPageBeginActionData;
      return {
        ...state,
        page,
        status: Status.Loading
      };
    }
    case Actions.FetchPageFailure: {
      return {
        ...state,
        status: Status.Ready
      };
    }
    case Actions.FetchPageSuccess: {
      const items = action.data as FetchPageSuccessActionData;
      return {
        ...state,
        items,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: BlogList.State = {
  id: "",
  items: [],
  page: 1,
  status: "None"
};
export const previewState: BlogList.State = {
  ...defaultState,
  items: [
    {
      authorName: "Dummy",
      commentCount: 1,
      excerpt: "Dummy",
      id: "",
      imageUrl: null,
      permalink: "/",
      publishedOnDate: new Date().toISOString(),
      title: "Dummy"
    }
  ],
  status: "Ready"
};
export default wrapReducer({ defaultState, reducer, previewState });
